import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=1dedd06b&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=1dedd06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dedd06b",
  null
  
)

export default component.exports